import { History } from "history";
import * as R from "ramda";
import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  AutoWidthClickableElement,
  EditableTitleLinkContainer,
  Input,
  SaveEditIcon,
  StyledFieldset,
  TitleLegend,
  ToggleEditButton,
} from "../../../App/Common/Components/EditableTitle";

const DropdownLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
`;

interface IEditableTitleLinkProps {
  addTitle: (title: string) => void;
  isMainTitle: boolean;
  currentTitle: string | null;
  defaultTitle?: string;
  fontSize?: number;
  maxWidth?: number;
  modifyTitle: (title: string) => void;
  navigate: () => void;
  to: History.LocationDescriptor<any>;
}

interface IEditableTitleLinkState {
  edit: boolean;
  title: string;
}

export default class EditableTitleLink extends React.Component<IEditableTitleLinkProps, IEditableTitleLinkState> {
  private input: React.RefObject<HTMLInputElement>;

  constructor(props: IEditableTitleLinkProps) {
    super(props);

    this.input = React.createRef();

    this.state = {
      edit: false,
      title: props.currentTitle || "",
    };
  }

  public componentDidUpdate(oldProps: IEditableTitleLinkProps) {
    if (oldProps.currentTitle !== this.props.currentTitle) {
      this.setState({ title: this.props.currentTitle || "" });
    }
  }

  public toggleEdit = () => {
    if (this.state.edit && this.editedTitle()) {
      this.submit();
    }

    this.setState({ edit: !this.state.edit });

    if (!this.state.edit) {
      setTimeout(() => this.input.current && this.input.current.select(), 0);
    }
  };

  public editTitle = () => this.input.current && this.setState({ title: this.input.current.value });

  public handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { currentTitle } = this.props;
    if (e.key === "Enter") {
      this.toggleEdit();
    }

    if (e.key === "Escape") {
      this.setState({ title: currentTitle || "", edit: !this.state.edit });
    }
  };

  public submit = () => {
    const { addTitle, currentTitle, modifyTitle } = this.props;
    const { current: input } = this.input;

    if (R.isNil(input)) {
      return;
    }

    if (!R.isNil(currentTitle)) {
      modifyTitle(input.value);
    } else {
      addTitle(input.value);
    }
  };

  public render() {
    const { title, edit } = this.state;
    const displayedTitle = title && title.length > 0 ? title : this.props.defaultTitle;
    return (
      <EditableTitleLinkContainer>
        <StyledFieldset isMainTitle={this.props.isMainTitle} edit={edit}>
          {edit && this.props.isMainTitle && <TitleLegend>{this.props.defaultTitle!.substring(8)} Title</TitleLegend>}
          {edit && (
            <Input
              autoFocus={true}
              onChange={this.editTitle}
              onKeyDown={this.handleKeyPress}
              ref={this.input}
              type="text"
              value={this.state.title}
            />
          )}
          {!edit && (
            <DropdownLink to={this.props.to} onClick={this.props.navigate}>
              <AutoWidthClickableElement>{displayedTitle} &nbsp;</AutoWidthClickableElement>
            </DropdownLink>
          )}
          <ToggleEditButton onClick={this.toggleEdit} edit={edit} aria-label="edit">
            <SaveEditIcon edit={edit} />
          </ToggleEditButton>
        </StyledFieldset>
      </EditableTitleLinkContainer>
    );
  }

  private editedTitle(): boolean {
    return this.state.title !== this.props.currentTitle;
  }
}
